import { useEffect } from "react"
import { Col, Form } from "react-bootstrap"
import Select from "react-select"
import styles from './RelatoriosPageStyle.module.css'

export default function RelatoriosPage() { 
    useEffect(() => {
        document.title = "Relatórios Despesas | OB PORTUS"
        
    }, [])
    
    return (
        <div id="main">
            <h1 id="titleMain">Relatórios de Despesas</h1>
            <br></br>
            <p>Selecione os filtros desejados para os relatórios:</p>
            <br></br>
            <div className="div-row" style={{alignItems: "start"}}>
                <Col className="col-4">
                    <FormFiltro label="Relatórios" id_form="relatorios" />
                    <FormFiltro label="Usuários" id_form="usuarios" />
                    <FormFiltro label="Categorias" id_form="categorias" />
                    <FormFiltro label="Clientes" id_form="clientes" />
                    <FormFiltro label="Formas de Pagamento" id_form="formas_pagamento" />
                    <FormFiltro label="Cartões" id_form="cartoes" />
                </Col>
                <Col className="col-3">
                    <BtnRelatorioDownload titulo="Resumo Geral Despesas" />
                    <BtnRelatorioDownload titulo="Valor por Categoria" />
                </Col>
            </div>
        </div>
    )
}

function FormFiltro({label, id_form}: iPropsFormFiltro) { 
    return (
        <Form.Group style={{marginBottom: "15px"}}>
            <Form.Label>{label}:</Form.Label>
            <Select name={id_form} id={id_form} options={[]}  isMulti closeMenuOnSelect={false} placeholder="Selecione" onChange={
                (choice:any) => {
                    
                }
            } styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: "#dee2e6"
                }),
            }} />
        </Form.Group>
    )
}
interface iPropsFormFiltro { 
    label: string
    id_form: string
}

function BtnRelatorioDownload({ titulo }: iPropsBtnRelatorioDownload) { 
    return (
        <div className={styles.btnRelatorio}>
            <p>{titulo}</p>
            <span className="material-symbols-outlined">
                arrow_forward_ios
            </span>
        </div>
    )
}
interface iPropsBtnRelatorioDownload { 
    titulo: string
}